import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { ClosedRow, LiveRow, PendingRow } from './PositionRows';

const EMPTY = {
  pending: 'No pending orders. Set your levels and press ACTIVATE.',
  live: 'No live trades yet. A pending order becomes live when price reaches its entry.',
  closed: 'No closed trades yet.',
};

export const PositionsPanel = ({ orders, tab, onTab, onCancel, onClose, onAuto, onMoveSl, busy }) => {
  const row = (k, o) => {
    if (k === 'pending') return <PendingRow key={o.order_id} o={o} onCancel={onCancel} onAuto={onAuto} onMoveSl={onMoveSl} busy={busy} />;
    if (k === 'live') return <LiveRow key={o.order_id} o={o} onClose={onClose} onAuto={onAuto} onMoveSl={onMoveSl} busy={busy} />;
    return <ClosedRow key={o.order_id} o={o} />;
  };
  return (
    <div className="sim-panel p-4 sm:p-5" data-testid="positions-panel">
      <Tabs value={tab} onValueChange={onTab}>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h2 className="sim-display text-base font-semibold text-white md:text-lg">My Positions</h2>
          <TabsList className="bg-white/5">
            {['pending', 'live', 'closed'].map((k) => (
              <TabsTrigger key={k} value={k} className="capitalize data-[state=active]:bg-sky-500 data-[state=active]:text-white" data-testid={`positions-tab-${k}`}>
                {k} ({orders[k]?.length || 0})
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        {['pending', 'live', 'closed'].map((k) => (
          <TabsContent key={k} value={k} className="mt-4 space-y-2">
            {orders[k]?.length ? orders[k].map((o) => row(k, o))
              : <p className="py-6 text-center text-sm text-slate-500" data-testid={`positions-empty-${k}`}>{EMPTY[k]}</p>}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
